import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatIcon } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { BottomNavButtonComponent, BottomNavComponent } from '@lfw/components';
import { NavigationBaseComponent } from '../navigation-base/navigation-base.component';
import { NavigationToolbarComponent } from '../navigation-toolbar/navigation-toolbar.component';
import { UserBottomSheetComponent } from './user-bottom-sheet/user-bottom-sheet.component';

@Component({
  selector: 'lfw-bottom-navigation',
  templateUrl: './bottom-navigation.component.html',
  styleUrls: ['./bottom-navigation.component.css'],
  imports: [
    NavigationToolbarComponent,
    MatIcon,
    RouterLink,
    RouterLinkActive,
    BottomNavComponent,
    BottomNavButtonComponent,
    AsyncPipe
  ]
})
export class BottomNavigationComponent extends NavigationBaseComponent {
  private readonly bottomSheet = inject(MatBottomSheet);

  openUserBottomSheet(): void {
    this.bottomSheet.open(UserBottomSheetComponent);
  }
}
